var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.supportedProperties, function(property) {
      return _c("configured-property", {
        key: property.key,
        attrs: {
          label: property.label,
          placeholder: property.placeholder,
          "property-key": property.key,
          "property-value": property.value,
          "is-sensitive": property.isSensitive
        },
        on: {
          "on-edit": function($event) {
            return _vm.updateProperty(property, $event)
          },
          "on-delete": function($event) {
            return _vm.deleteProperty(property)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }